import PropTypes from 'prop-types'
import styles from './GenericModal.module.css'

export const GenericItems = ({ items, body, onSelect, onDelete, onDeleteAll, onClose }) => {
  return (
    <>
      {items.length > 0 ? (
        <div>
          {onDeleteAll && (
            <button type="button" className={styles.deleteAllButton} onClick={onDeleteAll}>
              Borrar todos
            </button>
          )}
          <div className={styles.lista}>
            {items.map((item, index) => (
              <div
                key={`${item.valor || item.value}-${index}`}
                className={styles.itemRow}
                onClick={() => {
                  if (onSelect) {
                    onSelect(item)
                  }

                  onClose()
                }}
              >
                <span className={styles.itemText}>{item.label}</span>
                {onDelete && (
                  <button
                    type="button"
                    className={styles.deleteButton}
                    aria-label={`Eliminar ${item.label}`}
                    onClick={(event) => {
                      event.stopPropagation()
                      onDelete(item)
                    }}
                  >
                    Borrar
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        body && <p className={styles.bodyText}>{body}</p>
      )}
    </>
  )
}

GenericItems.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired
    })
  ),
  body: PropTypes.string,
  onSelect: PropTypes.func,
  onDelete: PropTypes.func,
  onDeleteAll: PropTypes.func,
  onClose: PropTypes.func
}
